/**
 * Converts a number to a Uint8Array using 64-bit float encoding.
 * Preserves both integer and fractional parts.
 *
 * @param num - The number to convert
 * @returns A Uint8Array containing the 8-byte big-endian float representation
 *
 * @example
 * ```ts
 * import { NumberToUint8 } from "@pdfking/tfunc"
 *
 * // Integer
 * const intBytes = NumberToUint8(42);
 *
 * // Float
 * const floatBytes = NumberToUint8(3.14159);
 *
 * // Negative
 * const negBytes = NumberToUint8(-42.5);
 *
 * // Use for hashing
 * const hash = await UInt8Hash([NumberToUint8(timestamp)]);
 * ```
 */
export const NumberToUint8 = (num: number): Uint8Array => {
  // Handle floating-point numbers by including both integer and fractional parts
  const buffer = new ArrayBuffer(8)
  const view = new DataView(buffer)

  // Store as 64-bit float to preserve both integer and fractional parts
  view.setFloat64(0, num, false) // false = big endian

  return new Uint8Array(buffer)
}
